export const codeSchemaFields = [{
  id: 'code',
  required: false,
  type: 'number',
  title: '状态码(等于0代表成功)'
}, {
  id: 'message',
  required: false,
  type: 'string',
  title: '接口返回的错误信息'
}];
//# sourceMappingURL=code.js.map
